"use client"
import { useUIStore } from "@/store/ui/ui-store";
import { RxHamburgerMenu } from "react-icons/rx";

export const BtnHamburger = () => {

    const openMenu = useUIStore(state => state.openSideMenu)

    return (
        <button className="p-2 bg-slate-100 dark:bg-transparent rounded-md lg:hidden border dark:text-white" onClick={openMenu}>
            <RxHamburgerMenu size={20} />
        </button>
    )
}
